export default "__VITE_PUBLIC_ASSET__8b2ba884__"